import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme: any) => {
  const styles: StyleRules = {
    // title page
    title: {
      color: '#596375',

      '& a': {
        color: '#596375',
        fontSize: theme.typography.pxToRem(16),
        lineHeight: theme.typography.pxToRem(16),
      },
      '& h2': {
        color: '#596375',
        fontSize: theme.typography.pxToRem(24),
        lineHeight: '24px',
        marginBottom: 0,
        marginTop: 5,
      },
    },
    hideOnPrint: {
      '@media print': {
        display: 'none',
      },
    },

    // icons
    tagsContainer: {
      display: 'flex',
      alignItems: 'center',
    },

    // row
    rowValues: {
      width: '100%',

      // row title
      '& h4': {
        marginLeft: 20,
        marginBottom: 5,
        fontSize: theme.typography.pxToRem(15),
        lineHeight: theme.typography.pxToRem(15),
      },

      // row content
      '& .content__values': {
        background: '#fff',
        padding: theme.typography.pxToRem(20),
        borderRadius: theme.shape.borderRadius,
        display: 'flex',
        justifyContent: 'space-between',
        boxShadow: theme.shadows[1],
        [theme.breakpoints.down('xs')]: {
          display: 'block',
          padding: theme.typography.pxToRem(12),
        },
        '& .value': {
          minWidth: '40px',
          fontSize: theme.typography.pxToRem(14),
          lineHeight: theme.typography.pxToRem(14),
          [theme.breakpoints.down('xs')]: {
            width: '50%',
            padding: '3px 16px',
            marginBottom: 8,
            display: 'inline-block',
          },
          '&:nth-child(odd)': {
            [theme.breakpoints.down('xs')]: {
              borderRight: '1px solid #ddd',
            },
          },
          '&.--number': {
            '& span': {
              textAlign: 'right',
              display: 'block',
            },
          },
          '& .value__title': {
            display: 'block',
            marginBottom: 10,
            fontWeight: 500,
            color: '#222',
          },
        },
      },

      // row total
      '& .content__total': {
        width: '100%',
        background: theme.palette.grey[300],
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(14),
        padding: '8px 20px',
        position: 'relative',
        top: '-3px',
        borderRadius: '0 0 4px 4px',
        borderTop: 0,
        color: '#222',
        boxShadow: theme.shadows[1],
        '& div:first-child': {
          fontWeight: 500,
        },
      },

      // row client
      '& .content__client': {
        marginTop: 12,
        background: '#fff',
        padding: theme.typography.pxToRem(20),
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[1],
        [theme.breakpoints.down('xs')]: {
          display: 'block',
          padding: theme.typography.pxToRem(12),
        },
        '& .row__client': {
          marginBottom: theme.typography.pxToRem(5),
          fontSize: theme.typography.pxToRem(14),
          display: 'flex',
          alignItems: 'flex-end',
          '& > $paymentImg': {
            marginRight: 8,
          },
          [theme.breakpoints.down('xs')]: {
            marginBottom: theme.typography.pxToRem(8),
          },
          '& .client__title': {
            fontWeight: 500,
            display: 'inline-block',
            minWidth: 85,
            [theme.breakpoints.down('xs')]: {
              display: 'block',
            },
          },
        },
      },
    },

    // modal
    modal: {
      textAlign: 'left',
      padding: '20px 20px 0',

      // title modal
      '& .modal__title': {
        width: '100%',
        display: 'block',
        fontSize: theme.typography.pxToRem(17),
        lineHeight: theme.typography.pxToRem(17),
        paddingRight: 50,
        color: '#222',
      },

      // close modal
      '& .modal__close': {
        position: 'absolute',
        top: 14,
        right: 20,
        zIndex: 2,
        lineHeight: 0,
        '& span': {
          cursor: 'pointer',
          fontSize: theme.typography.pxToRem(25),
        },
      },

      // content e-mail
      '& .modal__content': {
        paddingTop: 20,
      },

      '& .modal__footer': {
        width: '100%',
        textAlign: 'right',
      },
    },

    // afiliates
    affiliates: {
      width: '100%',
      '& .affiliates__title': {
        margin: '0 20px',
        marginBottom: 5,
        fontSize: theme.typography.pxToRem(15),
        lineHeight: theme.typography.pxToRem(15),
        display: 'flex',
        justifyContent: 'space-between',
        color: 'rgba(0, 0, 0, 0.85)',
        fontWeight: 500,
      },

      '& .affiliates__row': {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '5px 0 5px 0',
      },

      '& .affiliates__content': {
        padding: theme.typography.pxToRem(20),
        background: '#fff',
        boxShadow: theme.shadows[1],
        borderRadius: theme.typography.pxToRem(4),
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(14),

        [theme.breakpoints.down('xs')]: {
          padding: theme.typography.pxToRem(12),
        },

        '& div:first-child': {
          [theme.breakpoints.down('xs')]: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            paddingRight: 12,
          },
        },

        '&.--cooproducer': {
          flexDirection: 'column',
        },

        '& span.--commission': {
          fontSize: theme.typography.pxToRem(12),
        },

        // modifiquer to cooproducer
        '& .row__cooproducer': {
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          fontSize: theme.typography.pxToRem(14),
          lineHeight: theme.typography.pxToRem(14),
          marginBottom: 10,

          '&:last-child': {
            marginBottom: 0,
          },
        },
      },

      // content input adc affiliate
      affiliates__input: {
        width: '100%',
      },
    },

    // input
    input: {
      background: '#596375',
      color: '#fff',
      padding: '5px 15px !important',
      lineHeight: theme.typography.pxToRem(13),
      fontSize: theme.typography.pxToRem(13),

      '&:hover': {
        background: 'rgba(89, 99, 117, 0.8)',
      },
      '&:disabled': {
        background: 'rgba(89, 99, 117, 0.8)',
        color: '#fff !important',

        '&:hover, &:focus': {
          background: 'rgba(89, 99, 117, 0.8)',
          color: '#fff !important',
        },
      },
    },

    // items
    items: {
      width: '100%',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(14),

      // titles
      '& .items__title': {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 20px',
        color: 'rgba(0, 0, 0, 0.85)',
        fontWeight: 500,
        marginBottom: 5,
        fontSize: theme.typography.pxToRem(15),
        lineHeight: theme.typography.pxToRem(15),

        [theme.breakpoints.down('xs')]: {
          padding: '0 12px',
        },

        '& .title__item': {
          width: 'calc(100% - ((100px * 3) + 70px + 150px))',

          [theme.breakpoints.down('xs')]: {
            width: 'calc(100% - 100px)',
            paddingRight: 12,
          },
        },

        '& .title__qnt': {
          width: '70px',
          textAlign: 'left',

          [theme.breakpoints.down('xs')]: {
            width: '40px',
          },
        },

        '& .title__coupon': {
          width: '150px',
          textAlign: 'left',

          [theme.breakpoints.down('xs')]: {
            width: '40px',
          },
        },

        '& .title__discount': {
          width: '70px',
          textAlign: 'right',

          [theme.breakpoints.down('xs')]: {
            width: '40px',
          },
        },

        '& .title__unit': {
          width: '100px',
          textAlign: 'right',

          [theme.breakpoints.down('xs')]: {
            display: 'none',
          },
        },

        '& .title__total': {
          width: '100px',
          textAlign: 'right',

          [theme.breakpoints.down('xs')]: {
            width: '90px',
          },
        },
      },

      // content
      '& .items__content': {
        padding: theme.typography.pxToRem(20),
        background: '#fff',
        boxShadow: theme.shadows[1],
        borderRadius: theme.typography.pxToRem(4),
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(16),

        [theme.breakpoints.down('xs')]: {
          padding: theme.typography.pxToRem(12),
        },

        // items
        '& .items__row': {
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 10,

          '&:last-child': {
            marginBottom: 0,
          },

          '& .row__description': {
            width: 'calc(100% - ((100px * 3) + 70px + 150px))',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',

            [theme.breakpoints.down('xs')]: {
              width: 'calc(100% - 100px)',
              paddingRight: 12,
            },
          },

          '& .row__qnt': {
            width: '70px',
            textAlign: 'left',

            [theme.breakpoints.down('xs')]: {
              width: '40px',
            },
          },

          '& .row__coupon': {
            width: '150px',
            textAlign: 'left',
            display: 'flex',

            [theme.breakpoints.down('xs')]: {
              width: '40px',
            },
          },

          '& .row__unit': {
            width: '100px',
            textAlign: 'right',

            [theme.breakpoints.down('xs')]: {
              display: 'none',
            },
          },

          '& .row__total': {
            width: '100px',
            textAlign: 'right',

            [theme.breakpoints.down('xs')]: {
              width: '90px',
            },
          },
        },
      },

      // total
      '& .items__total': {
        width: '100%',
        background: theme.palette.grey[300],
        textAlign: 'right',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(14),
        padding: '8px 20px',
        position: 'relative',
        top: '-3px',
        borderRadius: '0 0 4px 4px',
        boxShadow: theme.shadows[1],
        borderTop: 0,
        color: '#222',
        fontWeight: 500,
      },
    },
    // multiple
    multiple: {
      width: '100%',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(14),

      // titles
      '& .multiple__title': {
        width: '250px',
        display: 'flex',
        justifyContent: 'space-between',
        color: 'rgba(0, 0, 0, 0.85)',
        fontWeight: 500,
        marginBottom: 5,
        fontSize: theme.typography.pxToRem(15),
        lineHeight: theme.typography.pxToRem(15),

        [theme.breakpoints.down('xs')]: {
          padding: '0 12px',
        },

        '& .title__item': {
          width: 'calc(100% - (130px * 3))',

          [theme.breakpoints.down('xs')]: {
            width: 'calc(100% - 130px)',
            paddingRight: 12,
          },
        },

        '& .title__qnt': {
          width: '130px',
          textAlign: 'right',

          [theme.breakpoints.down('xs')]: {
            width: '40px',
          },
        },

        '& .title__unit': {
          width: '130px',
          textAlign: 'right',

          [theme.breakpoints.down('xs')]: {
            display: 'none',
          },
        },

        '& .title__total': {
          width: '130px',
          textAlign: 'right',

          [theme.breakpoints.down('xs')]: {
            width: '90px',
          },
        },
      },

      // content
      '& .multiple__content': {
        padding: theme.typography.pxToRem(20),
        background: '#fff',
        boxShadow: theme.shadows[1],
        borderRadius: theme.typography.pxToRem(4),
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(16),

        [theme.breakpoints.down('xs')]: {
          padding: theme.typography.pxToRem(12),
        },

        // multiple
        '& .multiple__row': {
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 10,

          '&:last-child': {
            marginBottom: 0,
          },

          '& .row__description': {
            width: 'calc(100% - (130px * 3))',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',

            [theme.breakpoints.down('xs')]: {
              width: 'calc(100% - 130px)',
              paddingRight: 12,
            },
          },

          '& .row__qnt': {
            width: '130px',
            textAlign: 'right',

            [theme.breakpoints.down('xs')]: {
              width: '40px',
            },
          },

          '& .row__unit': {
            width: '130px',
            textAlign: 'right',

            [theme.breakpoints.down('xs')]: {
              display: 'none',
            },
          },

          '& .row__total': {
            width: '130px',
            textAlign: 'right',

            [theme.breakpoints.down('xs')]: {
              width: '90px',
            },
          },

          '& .row__card': {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            width: '130px',
            [theme.breakpoints.down('xs')]: {
              paddingRight: 12,
            },
          },
        },
      },

      // total
      '& .multiple__total': {
        width: '100%',
        background: theme.palette.grey[300],
        textAlign: 'right',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(14),
        padding: '8px 20px',
        position: 'relative',
        top: '-3px',
        borderRadius: '0 0 4px 4px',
        boxShadow: theme.shadows[1],
        borderTop: 0,
        color: '#222',
        fontWeight: 500,
      },
    },
    // access
    access: {
      width: '100%',

      // title
      '& h4': {
        marginLeft: 20,
        marginBottom: 5,
        fontSize: theme.typography.pxToRem(15),
        lineHeight: theme.typography.pxToRem(15),
      },
    },

    // history
    history: {
      width: '100%',
      boxShadow: theme.shadows[1],
      background: '#fff',
      borderRadius: theme.typography.pxToRem(4),
      overflow: 'hidden',
      marginTop: '1.4rem',

      '& svg': {
        width: '30px',
        height: '30px',
      },

      '& .col-left': {
        width: '130px',
        height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '10px 35px 10px 10px',
        background: '#596375',
        position: 'relative',
        float: 'left',
      },

      '& .col-right': {
        width: 'calc(100% - 130px)',
        height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '10px 10px 10px 35px',
        float: 'left',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(16),
        fontWeight: 500,
      },

      '& .history__title': {
        width: '100%',
        display: 'flex',
        height: 80,
        alignItems: 'center',

        '& .col-left': {
          padding: 0,
        },

        '& .col-right': {
          fontSize: theme.typography.pxToRem(20),
          lineHeight: theme.typography.pxToRem(22),
        },

        '& svg': {
          stroke: '#fff',
          margin: '0 auto',
          display: 'block',
          fill: '#596375',
        },
      },

      '& .history__content': {
        width: '100%',
        clear: 'both',
        borderTop: '1px solid #ddd',

        '& .history__item': {
          width: '100%',
          height: 80,
          fontWeight: 400,

          '&.--not-found': {
            height: 10,

            '& .col-left': {
              height: 10,
              padding: 0,
            },

            '& .col-right': {
              height: 10,
              padding: 0,
            },
          },

          // icon green
          '&.--green': {
            color: '#009358',

            '& .history__icon': {
              borderColor: '#009358',
            },

            '& svg': {
              fill: '#009358',
            },
          },

          // icon red
          '&.--red': {
            color: '#dc3f53',

            '& .history__icon': {
              borderColor: '#dc3f53',
            },

            '& svg': {
              fill: '#dc3f53',
            },
          },

          // icon orange
          '&.--orange': {
            color: '#F59211',

            '& .history__icon': {
              borderColor: '#F59211',
            },

            '& svg': {
              fill: '#F59211',
            },
          },

          '& .history__date': {
            color: '#fff',
            fontSize: 14,
            lineHeight: '16px',
            textAlign: 'right',
            width: '100%',

            '& span': {
              display: 'block',
              marginTop: 4,
            },
          },

          '& .history__icon': {
            top: '50%',
            right: '-22px',
            width: '45px',
            border: '2px solid #596375',
            height: '45px',
            position: 'absolute',
            background: '#fff',
            borderRadius: '50%',
            transform: 'translate(0, -50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '9px',
            lineHeight: '0',

            '& svg': {
              fill: '#596375',
            },
          },
        },
      },
    },
  };

  return styles;
});
